// extracted by mini-css-extract-plugin
export default {"Tags":"Tags_Tags__NzDF5","TagsContainer":"Tags_TagsContainer__6InkP","Title":"Tags_Title__-lwgX"};